import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './modules/user';
import usersAdminStore from './modules/users-admin';
import activitiesStore from './modules/activities';
import voyageReportsStore from './modules/voyage-reports';
import locationsStore from './modules/locations';
import vesselsStore from './modules/vessels';
import overviewStore from './modules/overview-report';
import bulkTransactionsStore from './modules/bulk-transactions';
import bulksStore from './modules/bulks';
import dataSyncStore from './modules/data-sync';
import tanksStore from './modules/tanks';
import dailyReportsStore from './modules/daily-reports';
import clientsStore from './modules/clients';
import passengersStore from './modules/passengers';
import safetyObservationsStore from './modules/safety-observations';

Vue.use(Vuex);

// MODULES
const modules = {
  userStore,
  usersAdminStore,
  activitiesStore,
  voyageReportsStore,
  locationsStore,
  vesselsStore,
  overviewStore,
  bulkTransactionsStore,
  bulksStore,
  dataSyncStore,
  tanksStore,
  dailyReportsStore,
  clientsStore,
  passengersStore,
  safetyObservationsStore
};

// TYPES
const MAIN_SET_COUNTER = 'MAIN_SET_COUNTER';

// STATE
const state = {
  counter: 1,
};

// MUTATIONS
const mutations = {
  [MAIN_SET_COUNTER](state, obj) {
    state.counter = obj.counter; // eslint-disable-line no-param-reassign
  },
};

// ACTIONS
const actions = ({
  setCounter({ commit }, obj) {
    commit(MAIN_SET_COUNTER, obj);
  },
});

// GETTERS
const getters = ({
});

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules,
  getters,
});
